export enum PROJECT_EDIT_MODES {
    DISABLED = 'DISABLED', // readonly
    REPUBLISH = 'REPUBLISH',
    SANBOX_MODE = 'SANDBOX_MODE',
    ENABLED = 'ENABLED',
    TEMPLATE_MODE = 'TEMPLATE_MODE'
}

export enum AUDIENCE_VIEW_MODES {
    FULL_SERVICE = 'FULL_SERVICE',
    SELF_SERVICE = 'SELF_SERVICE'
}

export enum AUDIENCE_RULE_TYPES {
    BUILT_IN_RULE = 'builtInAudienceRules',
    CUSTOM_RULE = 'customAudienceRules',
    SPECIAL_RULE = 'specialAudienceRules'
}

export enum ALERT_MESSAGE_TYPES {
    WARN = 'warning',
    DANGER = 'danger',
    INFO = 'info'
}
export interface TEMPLATE_QUESTION_SETTINGS {
    title: string;
    showDropdown?: boolean;
    predefinedList?: any[];
    showMedia?: boolean;
    alertMessages: any[];
    videoOnly?: boolean;
}
export enum SETUP_WIZARD_FORM_DATA_KEYS {
    NAME = 'name',
    COUNTRY = 'country',
    SAMPLE_SIZE = 'sampleSize',
    VIDEO = 'video',
    COPY_TEXT = 'copyText',
    HOTSPOT = 'hotspot',
    SUPPORTED_DEVICES = 'supportedDevices',
    CHECKOUT = 'checkout'
}
